import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import 'jspdf-autotable'; // Keep this import if needed by pdfMake internally
import * as moment from 'moment'; // Use moment for date formatting
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
// Assuming xlsx is available for Excel export
import * as XLSX from 'xlsx';
var AmcSettingComponent = /** @class */ (function () {
    function AmcSettingComponent(amcService) {
        this.amcService = amcService;
        this.amcList = [];
        this.filteredAmcList = [];
        // Pagination
        this.currentPage = 1;
        this.itemsPerPage = 5; // Reduced from 10 to 5
        this.totalPages = 1;
        // Filters
        this.statusFilter = 'all';
        this.searchTerm = '';
        // Modal
        this.showModal = false;
        this.editingAMC = null;
        // Toast
        this.showToast = false;
        this.toastMessage = '';
        this.toastType = 'success';
        // Download Dropdown
        this.showDownloadDropdown = false;
    }
    AmcSettingComponent.prototype.ngOnInit = function () {
        this.loadData();
        this.getIds();
    };
    AmcSettingComponent.prototype.loadData = function () {
        var _this = this;
        this.amcService.getamcreport().subscribe(function (res) {
            console.log("API Response:", res);
            var filtered = res.filter(function (amc) {
                // Include all records, even those with invalid dates
                return true;
            }).map(function (amc) { return (tslib_1.__assign({}, amc, { customer: (amc.customer === null || amc.customer === undefined || amc.customer === '' || (typeof amc.customer === 'string' && amc.customer.toLowerCase() === 'null')) ? 'No name provided' : amc.customer })); });
            // Sort by nearest expiry date (ascending)
            filtered.sort(function (a, b) {
                var expiryA = _this.getExpiryDate(a);
                var expiryB = _this.getExpiryDate(b);
                var timeA = expiryA ? expiryA.getTime() : Infinity;
                var timeB = expiryB ? expiryB.getTime() : Infinity;
                return timeA - timeB;
            });
            _this.amcList = filtered;
            console.log("Processed AMC List:", _this.amcList);
            _this.applyFilters();
        });
    };
    // Stats methods
    AmcSettingComponent.prototype.getExpiredCount = function () {
        var _this = this;
        return this.amcList.filter(function (amc) { return _this.getAMCStatus(amc) === 'expired'; }).length;
    };
    AmcSettingComponent.prototype.getExpiringSoonCount = function () {
        var _this = this;
        return this.amcList.filter(function (amc) { return _this.getAMCStatus(amc) === 'warning'; }).length;
    };
    AmcSettingComponent.prototype.getActiveCount = function () {
        var _this = this;
        return this.amcList.filter(function (amc) { return _this.getAMCStatus(amc) === 'active'; }).length;
    };
    AmcSettingComponent.prototype.filterByStatus = function (status) {
        this.statusFilter = status;
        this.applyFilters();
    };
    AmcSettingComponent.prototype.getIds = function () {
        var _this = this;
        this.amcService.getamcids().subscribe(function (res) {
            console.log("API Response:all ids", res);
            _this.deviceList = res;
        });
    };
    AmcSettingComponent.prototype.applyFilters = function () {
        var _this = this;
        var filtered = Array.from(this.amcList);
        console.log("filtered list", filtered);
        // Status filter
        if (this.statusFilter !== 'all') {
            filtered = filtered.filter(function (amc) {
                var status = _this.getAMCStatus(amc);
                return status === _this.statusFilter;
            });
        }
        // Search filter
        if (this.searchTerm) {
            var search_1 = this.searchTerm.toLowerCase();
            filtered = filtered.filter(function (amc) {
                return (amc.device_id && amc.device_id.toLowerCase().includes(search_1)) ||
                    (amc.transformer_id && amc.transformer_id.toLowerCase().includes(search_1)) ||
                    (amc.customer && amc.customer.toLowerCase().includes(search_1));
            } // ✅ added customer name
            );
        }
        this.filteredAmcList = filtered;
        this.totalPages = Math.ceil(this.filteredAmcList.length / this.itemsPerPage);
        this.currentPage = 1;
    };
    AmcSettingComponent.prototype.onDeviceChange = function () {
        var _this = this;
        var selectedDevice = this.deviceList.find(function (d) { return d.deviceId === _this.editingAMC.device_id; });
        if (selectedDevice) {
            this.editingAMC.transformer_id = selectedDevice.serialnumber;
        }
        else {
            this.editingAMC.transformer_id = '';
        }
    };
    AmcSettingComponent.prototype.getAMCStatus = function (amc) {
        var expiryDate = this.getExpiryDate(amc);
        if (!expiryDate)
            return 'expired'; // Treat invalid dates as expired
        var now = new Date();
        var twoMonthsFromNow = new Date();
        twoMonthsFromNow.setMonth(now.getMonth() + 2);
        if (expiryDate < now)
            return 'expired';
        if (expiryDate <= twoMonthsFromNow)
            return 'warning';
        return 'active';
    };
    AmcSettingComponent.prototype.getExpiryDate = function (amc) {
        if (!amc.renewal_date || amc.renewal_date === "0000-00-00") {
            return null;
        }
        try {
            var renewal = new Date(amc.renewal_date);
            if (isNaN(renewal.getTime())) {
                return null;
            }
            var period = Number(amc.amc_period);
            // If period is 0, return the renewal date as expiry date
            if (period === 0) {
                return renewal;
            }
            var expiry = new Date(renewal);
            expiry.setFullYear(expiry.getFullYear() + period);
            return expiry;
        }
        catch (error) {
            console.error('Error parsing date:', error);
            return null;
        }
    };
    AmcSettingComponent.prototype.formatDate = function (dateString) {
        if (!dateString) {
            return "Not Set";
        }
        if (typeof dateString === 'string' && dateString === "0000-00-00") {
            return "Not Set";
        }
        try {
            var date = new Date(dateString);
            if (isNaN(date.getTime())) {
                return "Invalid Date";
            }
            // Use moment for consistent formatting if available and preferred
            return moment(date).format('MMM D, YYYY');
            // return date.toLocaleDateString('en-US', {
            //   year: 'numeric',
            //   month: 'short',
            //   day: 'numeric'
            // });
        }
        catch (error) {
            return "Invalid Date";
        }
    };
    AmcSettingComponent.prototype.getDaysUntilExpiry = function (amc) {
        var expiryDate = this.getExpiryDate(amc);
        if (!expiryDate)
            return "N/A";
        var now = new Date();
        var diffTime = expiryDate.getTime() - now.getTime();
        var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays < 0) {
            return "Expired " + Math.abs(diffDays) + " days ago";
        }
        else if (diffDays === 0) {
            return "Expires today";
        }
        else {
            return "Expires in " + diffDays + " days";
        }
    };
    Object.defineProperty(AmcSettingComponent.prototype, "paginatedItems", {
        // Pagination methods
        get: function () {
            var start = (this.currentPage - 1) * this.itemsPerPage;
            return this.filteredAmcList.slice(start, start + this.itemsPerPage);
        },
        enumerable: true,
        configurable: true
    });
    AmcSettingComponent.prototype.changePage = function (page) {
        if (page >= 1 && page <= this.totalPages) {
            this.currentPage = page;
        }
    };
    Object.defineProperty(AmcSettingComponent.prototype, "pagesToDisplay", {
        get: function () {
            var pages = [];
            var startPage = Math.max(1, this.currentPage - 1);
            var endPage = Math.min(this.totalPages, this.currentPage + 2); // Show current, prev, and next two pages
            for (var i = startPage; i <= endPage; i++) {
                pages.push(i);
            }
            return pages;
        },
        enumerable: true,
        configurable: true
    });
    // Download Dropdown methods
    AmcSettingComponent.prototype.toggleDownloadDropdown = function () {
        this.showDownloadDropdown = !this.showDownloadDropdown;
    };
    AmcSettingComponent.prototype.downloadReport = function (format) {
        var _this = this;
        console.log("Download report requested in " + format + " format.");
        // Map the filtered data to a format suitable for reports
        var dataToReport = this.filteredAmcList.map(function (item) { return ({
            'Device ID': item.device_id || '',
            'Transformer ID': item.transformer_id || '',
            'Customer': item.customer === 'No name provided' ? 'No name provided' : (item.customer || 'No name provided'),
            'Renewal Date': _this.formatDate(item.renewal_date),
            'AMC Period (Years)': item.amc_period !== null && item.amc_period !== undefined ? item.amc_period : '',
            'Status': _this.getAMCStatus(item).replace(/^./, function (str) { return str.toUpperCase(); }),
            'Expiry Date': _this.formatDate(_this.getExpiryDate(item)),
            'Expiry Info': _this.getDaysUntilExpiry(item),
            'Dashboard Access': item.dashboard_access === 1 ? 'Yes' : 'No'
        }); });
        var reportFileName = "amc_report_" + moment().format('YYYYMMDD_HHmmss'); // Generate dynamic file name
        if (format === 'excel') {
            this.showToastMessage('Generating Excel report...', 'warning');
            // Create a new workbook and worksheet
            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet([]); // Create an empty worksheet
            // Add title
            var reportTitle = 'AMC Status Report';
            XLSX.utils.sheet_add_aoa(ws, [[reportTitle]], { origin: 'A1' });
            // Define headers from dataToReport keys
            var headers = Object.keys(dataToReport[0]);
            // Add headers row (starting from row 3, A3) - Leave row 2 blank for spacing
            XLSX.utils.sheet_add_aoa(ws, [headers], { origin: 'A3' });
            // Add data rows (starting from row 4, A4)
            // XLSX.utils.sheet_add_json expects an array of objects
            XLSX.utils.sheet_add_json(ws, dataToReport, { origin: 'A4', skipHeader: true });
            // Optional: Merge cells for the title for better appearance
            if (headers.length > 0) {
                // Get the column letter for the last header
                var lastHeaderCol = XLSX.utils.encode_col(headers.length - 1);
                var mergeRange = "A1:" + lastHeaderCol + "1";
                if (!ws['!merges'])
                    ws['!merges'] = [];
                ws['!merges'].push(XLSX.utils.decode_range(mergeRange));
                // Optional: Basic styling for the title cell (bold)
                var titleCell = ws['A1'];
                if (titleCell) {
                    titleCell.s = {
                        font: { bold: true, sz: 14 }
                        // alignment: { horizontal: 'center' } // Alignment is tricky without full style support or iterating cells
                    };
                }
                // Optional: Basic styling for header row (bold)
                var headerRowRange = XLSX.utils.encode_range({ r: 2, c: 0 }, { r: 2, c: headers.length - 1 });
                var headerCells = XLSX.utils.decode_range(headerRowRange);
                for (var C = headerCells.s.c; C <= headerCells.e.c; ++C) {
                    var cell_address = { r: headerCells.s.r, c: C };
                    var cell_ref = XLSX.utils.encode_cell(cell_address);
                    var headerCell = ws[cell_ref];
                    if (headerCell) {
                        headerCell.s = {
                            font: { bold: true },
                            fill: {
                                fgColor: { rgb: "FFF2F2F2" } // Light grey color in ARGB format
                            }
                            // alignment: { horizontal: 'center' } // Again, alignment is more complex
                        };
                    }
                }
            }
            // Append the worksheet to the workbook
            XLSX.utils.book_append_sheet(wb, ws, 'AMC Report');
            // Write and download the file
            XLSX.writeFile(wb, reportFileName + ".xlsx");
            setTimeout(function () {
                _this.showToastMessage('Excel report download initiated.', 'success');
            }, 1000);
        }
        else if (format === 'pdf') {
            this.showToastMessage('Generating PDF report...', 'warning');
            var documentDefinition = {
                header: { text: 'AMC Status Report', style: 'reportHeader', alignment: 'center', margin: [0, 15, 0, 0] },
                content: [
                    { text: '\n' },
                    {
                        table: {
                            headerRows: 1,
                            // Define widths for columns - Use * for proportional, auto for content
                            widths: ['*', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', '*'],
                            body: [
                                // Table Header - explicitly define with styles
                                [
                                    { text: 'Device ID', style: 'tableHeader' },
                                    { text: 'Transformer ID', style: 'tableHeader' },
                                    { text: 'Customer', style: 'tableHeader' },
                                    { text: 'Renewal Date', style: 'tableHeader' },
                                    { text: 'AMC Period (Years)', style: 'tableHeader' },
                                    { text: 'Status', style: 'tableHeader' },
                                    { text: 'Expiry Date', style: 'tableHeader' },
                                    { text: 'Expiry Info', style: 'tableHeader' },
                                    { text: 'Dashboard Access', style: 'tableHeader' }
                                ]
                                // Table Body - Map data to array of arrays and concatenate
                            ].concat(dataToReport.map(function (row) { return [
                                row['Device ID'],
                                row['Transformer ID'],
                                row['Customer'],
                                row['Renewal Date'],
                                row['AMC Period (Years)'],
                                row['Status'],
                                row['Expiry Date'],
                                row['Expiry Info'],
                                row['Dashboard Access']
                            ]; }))
                        },
                        layout: {
                            hLineWidth: function (i, node) { return (i === 0 || i === node.table.body.length) ? 1 : 1; },
                            vLineWidth: function (i, node) { return 1; },
                            hLineColor: function (i, node) { return (i === 0 || i === node.table.body.length) ? '#999' : '#eee'; },
                            vLineColor: function (i, node) { return '#eee'; },
                            paddingLeft: function (i, node) { return 8; },
                            paddingRight: function (i, node) { return 8; },
                            paddingTop: function (i, node) { return 5; },
                            paddingBottom: function (i, node) { return 5; }
                        }
                    }
                ],
                styles: {
                    reportHeader: {
                        fontSize: 16,
                        bold: true,
                        margin: [0, 10, 0, 10]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 10,
                        fillColor: '#f2f2f2',
                        alignment: 'center',
                    },
                },
                pageMargins: [40, 60, 40, 60]
            };
            pdfMake.createPdf(documentDefinition).download(reportFileName + ".pdf");
            setTimeout(function () {
                _this.showToastMessage('PDF report download initiated.', 'success');
            }, 1000);
        }
        // Close the dropdown after selection
        this.showDownloadDropdown = false;
    };
    // Modal methods
    AmcSettingComponent.prototype.showAddAMCModal = function () {
        this.editingAMC = {
            device_id: '',
            transformer_id: '',
            customer: '',
            renewal_date: new Date().toISOString().split('T')[0],
            amc_period: 1,
            dashboard_access: 0
        };
        this.showModal = true;
    };
    AmcSettingComponent.prototype.showEditModal = function (amc) {
        // Create a copy of the AMC and ensure dashboard_access is a number\
        console.log("asdsadsasd", amc);
        if (amc.renewal_date) {
            var d = new Date(amc.renewal_date);
            amc.renewal_date = d.toISOString().substring(0, 10);
            // gives "2022-03-21"
        }
        this.editingAMC = tslib_1.__assign({}, amc, { dashboard_access: amc.dashboard_access === 1 ? 1 : 0 });
        this.showModal = true;
        console.log("asdsad", this.editingAMC);
    };
    AmcSettingComponent.prototype.closeModal = function () {
        this.showModal = false;
        this.editingAMC = null;
    };
    AmcSettingComponent.prototype.saveAMC = function () {
        var _this = this;
        if (!this.validateAMCData()) {
            return;
        }
        var amcData = tslib_1.__assign({}, this.editingAMC, { dashboard_access: this.editingAMC.dashboard_access ? 1 : 0 });
        var saveOperation = this.editingAMC.id
            ? this.amcService.updateAMC(amcData)
            : this.amcService.addAMC(amcData);
        saveOperation.subscribe({
            next: function (response) {
                _this.showToastMessage("AMC " + (_this.editingAMC.id ? 'updated' : 'added') + " successfully", 'success');
                _this.closeModal();
                _this.loadData(); // Reload the data
            },
            error: function (error) {
                console.error('Error saving AMC:', error);
                _this.showToastMessage("Failed to " + (_this.editingAMC.id ? 'update' : 'add') + " AMC", 'error');
            }
        });
    };
    AmcSettingComponent.prototype.validateAMCData = function () {
        if (!this.editingAMC.device_id || this.editingAMC.device_id.trim() === '') {
            this.showToastMessage('Device ID is required', 'error');
            return false;
        }
        if (!this.editingAMC.transformer_id || this.editingAMC.transformer_id.trim() === '') {
            this.showToastMessage('Transformer ID is required', 'error');
            return false;
        }
        if (!this.editingAMC.customer || this.editingAMC.customer.trim() === '') {
            this.showToastMessage('Customer is required', 'error');
            return false;
        }
        if (!this.editingAMC.renewal_date) {
            this.showToastMessage('Renewal date is required', 'error');
            return false;
        }
        if (this.editingAMC.amc_period < 0) {
            this.showToastMessage('AMC period cannot be negative', 'error');
            return false;
        }
        return true;
    };
    // Toast methods
    AmcSettingComponent.prototype.showToastMessage = function (message, type) {
        var _this = this;
        if (type === void 0) { type = 'success'; }
        this.toastMessage = message;
        this.toastType = type;
        this.showToast = true;
        if (this.toastTimeout) {
            clearTimeout(this.toastTimeout);
        }
        this.toastTimeout = setTimeout(function () {
            _this.showToast = false;
        }, 3000);
    };
    // Input change handlers
    AmcSettingComponent.prototype.onRenewalDateChange = function (amc) {
        // You can add validation or additional logic here
        console.log('Renewal date changed:', amc);
    };
    AmcSettingComponent.prototype.onAMCPeriodChange = function (amc) {
        // You can add validation or additional logic here
        console.log('AMC period changed:', amc);
    };
    // Add a helper method to format customer name
    AmcSettingComponent.prototype.getCustomerName = function (customer) {
        if (!customer)
            return 'Name not provided';
        if (typeof customer === 'string' && customer.trim() === '')
            return 'Name not provided';
        return customer;
    };
    // Add method to format customer name
    AmcSettingComponent.prototype.formatCustomerName = function (customer) {
        if (customer === null || customer === undefined || customer === '') {
            return 'No name provided';
        }
        return customer;
    };
    return AmcSettingComponent;
}());
export { AmcSettingComponent };
